import CardWithRoles from "components/card/CardWithRoles";
import accessControlImage from "./icons/public-api-access-control.svg";

export default function ApiKeysCard() {
  return (
    <CardWithRoles
      name="API - API Keys"
      image={accessControlImage}
      description="Authenticate requests to the platform's web services and APIs. Attached service products determine which services the key can execute and how many transactions are allowed."
      targetRoles={["Project leader", "Admin"]}
      link={`/api/api-keys`}
      testid="public-api-api-keys"
    />
  );
}
